import { Component, inject, OnInit, signal, effect, untracked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppStateService } from '../../services/app-state.service';
import { ExternalLiquidityService } from '../../services/external-liquidity.service';
import { Web3Service } from '../../services/web3.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-financial-terminal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './financial-terminal.component.html'
})
export class FinancialTerminalComponent implements OnInit {
  public state = inject(AppStateService);
  private externalService = inject(ExternalLiquidityService);
  private web3Service = inject(Web3Service);
  private http = inject(HttpClient);

  topTokens = signal<any[]>([]);
  topStakingPools = signal<any[]>([]);

  constructor() {
    effect(() => {
      const chainId = this.web3Service.chainId();
      untracked(() => {
        this.fetchData(chainId);
      });
    });
  }

  ngOnInit() {}

  async fetchData(chainId?: number) {
    try {
      const chainIdStr = chainId ? chainId.toString() : undefined;
      const tokensRes = await this.externalService.getTokens(1, 5, '', chainIdStr);
      this.topTokens.set(tokensRes.data || []);

      let stakingUrl = `${environment.apiUrl}/user/staking/list?page=1&limit=5`;
      if (chainId) {
        stakingUrl += `&chainId=${chainId}`;
      }

      this.http.get<any>(stakingUrl)
        .subscribe({
          next: (res) => {
            if (res && res.status && res.data && res.data.data) {
              const globalTokens = this.state.tokens();
              const mapped = res.data.data.map((pool: any) => {
                const displaySymbol = (pool.stakingTokenSymbol === 'DXOR' || pool.stakingTokenSymbol === 'DEXOR') ? 'DEX' : (pool.stakingTokenSymbol || 'Unknown');
                const tok = globalTokens.find((t: any) => t.symbol === pool.stakingTokenSymbol);
                return {
                  name: `${displaySymbol} Staking`,
                  tokenName: displaySymbol,
                  badge: displaySymbol === 'DEX' ? 'Exclusive' : 'Core',
                  apy: pool.lockTiers && pool.lockTiers.length > 0 
                    ? (Math.max(...pool.lockTiers.map((t: any) => Number(t.apyBps))) / 100).toFixed(2)
                    : 0,
                  rawTotalStaked: Number(pool.totalStaked || 0),
                  logoUrl: tok?.logoUrl || '',
                };
              });
              this.topStakingPools.set(mapped);
            } else {
              this.topStakingPools.set([]);
            }
          },
          error: () => {
            this.topStakingPools.set([]);
          }
        });
        
    } catch (e) {
      console.error('Failed to fetch financial terminal stats', e);
    }
  }
}
